import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { AngleDownLightIcon, AngleUpLightIcon } from '@mm/icons';
import './CounterInput.pcss';

type Props = {
  value?: number;
  max?: number;
  min?: number;
  onChange?: (value?: number) => void; // provides capped value
  onInputChange?: (value: string) => void; // to get original user input
  onBlur?: () => void;
  css?: {
    container?: string;
    btn?: string;
    input?: string;
    icon?: string;
  };
};

export const CounterInput = ({
  value = 0,
  css,
  max = Infinity,
  min = -Infinity,
  onChange,
  onBlur,
  onInputChange,
}: Props) => {
  const [count, setCount] = useState(value);
  const [inputValue, setInputValue] = useState<string>(value?.toString());

  const cn = {
    container: classnames('c-counter-input', css?.container),
    btn: classnames('c-counter-input__button', css?.btn),
    icon: classnames('c-counter-input__icon', css?.icon),
    input: classnames('c-counter-input__input', css?.input),
  };

  const decrement = () => {
    if (count <= min) {
      return;
    }

    const next = count - 1;

    setInputValue(next?.toString());
    setCount(next);
  };

  const increment = () => {
    if (count >= max) {
      return;
    }

    const next = count + 1;

    setInputValue(next?.toString());
    setCount(next);
  };

  const handleChangeInput = ({ target: { value } }) => {
    setInputValue(value);
    onInputChange?.(value);
  };

  const handleBlur = () => {
    let num = parseInt(inputValue, 10);
    num = num > max ? max : num;
    num = num < min ? min : num;

    if (isNaN(num)) {
      setInputValue(count?.toString());
    } else {
      setInputValue(num?.toString());
      setCount(num);
    }

    if (onBlur) {
      onBlur();
    }
  };

  useEffect(() => {
    if (onChange && count !== value) {
      onChange(count);
    }
  }, [count]);

  useEffect(() => {
    if (value !== count && value) {
      setCount(value);
      setInputValue(value?.toString());
    }
  }, [value]);

  return (
    <div className={cn.container}>
      <div className={cn.btn} onClick={increment}>
        <AngleUpLightIcon className={cn.icon} color="#8C8C8C" />
      </div>
      <input
        className={cn.input}
        type="text"
        value={inputValue}
        onChange={handleChangeInput}
        onBlur={handleBlur}
      />
      <div className={cn.btn} onClick={decrement}>
        <AngleDownLightIcon className={cn.icon} color="#8C8C8C" />
      </div>
    </div>
  );
};
